import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { customerMobileAuthOtpPost } from '../../../../api-client/api-gqcust-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const postCustomerMobileAuthOtp = createAsyncThunk(
    'postCustomerMobileAuthOtp/Post',
    async (body, { rejectWithValue }) => {
        try {
            const response = await customerMobileAuthOtpPost(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'POST_CUSTOMER_MOBILE_AUTH_OTP_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const postCustomerMobileAuthOtpSlice = createSlice({
    name: 'postCustomerMobileAuthOtp',
    initialState,
    extraReducers: {
        [postCustomerMobileAuthOtp.pending]: (state) => {
            state.loading = true;
        },
        [postCustomerMobileAuthOtp.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [postCustomerMobileAuthOtp.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const postCustomerMobileAuthOtpSelector = (state) => state.postCustomerMobileAuthOtp;
export const postCustomerMobileAuthOtpReducer = postCustomerMobileAuthOtpSlice.reducer;
